import { useState, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { StateRedux } from '../../store/type-redux';
import LogoMtrix from '../../images/logo-mtrix-light.png';
import { doRefreshToken } from '../../utils';

const Sidebar = (): ReactElement => {
  const { realm: { nameRealm }, toggled: alternado } = useSelector((state: StateRedux) => state);

  const [toggled, setToggled] = useState(alternado);

  // Verifica se é necessário realizar o refresh token
  doRefreshToken.getRefreshToken();

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const toggle = () => {
    setToggled(!toggled);

    dispatch({
      type: 'TOGGLE',
      toggled: !toggled,
    });
  };

  return (
    <ul
      className={`side-menu navbar-nav bg-mtrix-dark sidebar sidebar-dark accordion ${!toggled || 'toggled'}`}
      id="accordionSidebar"
    >
      <Link
        className="sidebar-brand d-flex align-items-center justify-content-center"
        to="/home"
      >
        <div className="sidebar-brand-icon">
          <img src={LogoMtrix} height={40} alt="Logo Mtrix" />
        </div>
      </Link>

      <br />

      <hr className="sidebar-divider my-0" />
      <li
        className="nav-item active d-flex align-items-center"
        style={{ marginRight: 20 }}
      >
        <span className="nav-link">
          {nameRealm}
        </span>
      </li>

      <li className="nav-item" />
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        {t('sidebar.servicos')}
      </div>

      <li className="nav-item">
        <Link to="/usuarios" className="nav-link">
          <i className="fas fa-fw fa-user" />
          <span>{t('sidebar.usuarios')}</span>
        </Link>
      </li>

      <li className="nav-item">
        <Link to="/permissoes" className="nav-link">
          <i className="fas fa-fw fa-key" />
          <span>{t('sidebar.perfil')}</span>
        </Link>
      </li>

      <hr className="sidebar-divider d-none d-md-block" />
      <div className="text-center d-none d-md-inline">
        <Button
          className="rounded-circle border-0"
          id="sidebarToggle"
          onClick={toggle}
        />
      </div>
    </ul>
  );
};

export default Sidebar;
